import { createContext, useContext } from 'react';
import { TableV3FilterItem } from 'common/table/types/TableV3';

type FilterSelectionDeferral = {
  defer: (commit: () => void) => void;
  subscribeToSettled: (listener: () => void) => () => void;
};

type FilterSelectionControl = {
  setSelection: (values: string[]) => void;
  getSelectedItems: () => TableV3FilterItem[];
  deferral?: FilterSelectionDeferral;
};

/**
 * Lets content inside a filter dropdown replace what it shows as selected;
 * no prop can carry that down once the dropdown is open.
 */
export const TableV3FilterSelectionContext =
  createContext<FilterSelectionControl | null>(null);

export const useTableV3FilterSelection = () =>
  useContext(TableV3FilterSelectionContext);
